import { propIs } from 'ramda';

/**
isArray is used to check is give value type is Array
* @param value { any } value can be any value
if give is array value then returns true other wise return false
*/
export const isArray = (value: any) => {
  return propIs(Array, 'value', { value })
}

/**
isArray is used to check is give value type is Array
* @param value { any } value can be any value
if give is Number value then returns true other wise return false
*/
export const isNumber = (value: any) => {
  return propIs(Number, 'value', { value })
}

/**
isArray is used to check is give value type is Array
* @param value { any } value can be any value
if give is String value then returns true other wise return false
*/
export const isString = (value: any) => {
  return propIs(String, 'value', { value })
}

/**
isArray is used to check is give value type is Array
* @param value { any } value can be any value
if give is Boolean value then returns true other wise return false
*/
export const isBoolean = (value: any) => {
  return propIs(Boolean, 'value', { value })
}

/**
isObject is used to check is give value type is object
* @param value { any } value can be any value
if give is Object value then returns true other wise return false
*/
export const isObject = (value: any) => {
  return propIs(Object, 'value', { value })
}
